import Login from 'components/pages/Login';
import Page404 from 'components/pages/404';
import Page500 from 'components/pages/500';

export {
    Login,
    Page404,
    Page500,
}


// WEBPACK FOOTER //
// ./src/components/pages/index.js